var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorncob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7809 2.80588L9.19248 1.21868C9.05104 1.07859 8.85996 1 8.66081 1C8.46167 1 8.27059 1.07859 8.12916 1.21868L2.83294 6.51213C2.69275 6.65346 2.61409 6.8444 2.61409 7.04339C2.61409 7.24238 2.69275 7.43332 2.83294 7.57465L3.10266 7.84417L1.52865 9.41656C1.23676 9.70815 1.23673 10.1812 1.52857 10.4728C1.82002 10.7641 2.2923 10.7641 2.58383 10.473L4.15879 8.90011L4.42072 9.16185C4.56219 9.30211 4.7534 9.38082 4.95268 9.38082C5.15197 9.38082 5.34318 9.30211 5.48464 9.16185L10.7809 3.8696C10.9212 3.72824 11 3.53717 11 3.33803C11 3.1389 10.9212 2.94783 10.7809 2.80647",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorncob);
export default __webpack_public_path__ + "static/media/corncob.346061c35a2016b895a04c66c3a0b6c6.svg";
export { ForwardRef as ReactComponent };